<template>
  <vue-tel-input
    class="form-control"
    v-model="phone"
    mode="international"
    :validCharactersOnly="true"
    :showDialCode="true"
    :autoFormat="true"
    @validate="validatePhone"
  ></vue-tel-input>
</template>
<script>
import { ref } from "vue";
import { VueTelInput } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";

export default {
  components: {
    VueTelInput,
  },

  setup(props, { emit }) {
    const phone = ref(null);
    const validationError = ref(false);
    const validatePhone = async (value) => {
      try {
        if (!phone.value || phone.value.length < 1) {
          emit("emitValidation", false);
        }
        if (value && value.number !== undefined && value.valid !== undefined) {
          if (!value.valid) {
            validationError.value = true;
            emit("emitValidation", true);
          } else {
            validationError.value = true;
            emit("emitValidation", false);
          }
        }
      } catch (error) {
        validationError.value = error.message;
      }
    };

    return {
      phone,
      validationError,
      validatePhone,
    };
  },
};
</script>
<style scoped>
.vue-tel-input.form-control {
  display: flex;
}
</style>
